import "./CurrentCauses.module.css";
import Header from "@/reusable_sections/Header";
import Awareness from "./sections/Awareness";
import FeaturedCauses from "./sections/FeaturedCauses";
import Causes from "./sections/Causes";
import Footer from "@/reusable_sections/Footer";
export default function CurrentCausesPage() {
  return <div>
      <Header />
      <Awareness />
      <FeaturedCauses />
      <Causes />
      <Footer />
    </div>;
}